module.exports = __webpack_public_path__ + "img/logo.294b5f62.png";